/* L4M v189 — compact Pandectes cookie banner, idempotent runtime override.
   Important: the old English branch rewrote .cc-message on every MutationObserver
   cycle because document.lang === "en" stayed true. Replacing text creates another
   childList mutation, which could create a perpetual English-only mutation/rAF loop.
   This version rewrites the message only when needed and marks the rendered message
   so our own DOM update cannot trigger an endless loop. */
(function () {
  'use strict';

  var scheduled = false;
  var EN_COMPACT_TEXT = 'Cookies for analytics & marketing.';

  function imp(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function isEnglishDocument() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang === 'en' || lang.indexOf('en-') === 0;
  }

  function compactEnglishMessage(message) {
    if (!message || !isEnglishDocument()) return;

    var currentText = (message.textContent || '').replace(/\s+/g, ' ').trim();

    // Already processed by this version: never rewrite again.
    if (message.dataset.l4mCookieCompacted === '1') return;

    // If Pandectes has already rendered our compact copy (for example after a
    // partial refresh), simply mark it and leave the DOM untouched.
    if (currentText.indexOf(EN_COMPACT_TEXT) === 0) {
      message.dataset.l4mCookieCompacted = '1';
      return;
    }

    var looksLikePandectesEnglish =
      !currentText ||
      /This website uses cookies|We use cookies to improve|We use cookies for analytics|Learn More/i.test(currentText);

    if (!looksLikePandectesEnglish) return;

    var existingLink = message.querySelector('a');
    var href = existingLink ? existingLink.getAttribute('href') : null;
    var target = existingLink ? existingLink.getAttribute('target') : null;

    // Mark BEFORE changing child nodes. The observer can see the mutation, but
    // the next scheduled pass will immediately return without another rewrite.
    message.dataset.l4mCookieCompacted = '1';
    message.textContent = EN_COMPACT_TEXT + ' ';

    if (href) {
      var link = document.createElement('a');
      link.className = 'cc-link';
      link.href = href;
      if (target) link.target = target;
      link.textContent = 'Privacy';
      message.appendChild(link);
    }
  }

  function applyCompactCookieBanner() {
    scheduled = false;

    var banner = document.querySelector('#cookie-consent-dialogBox .pd-cookie-banner-window') ||
                 document.querySelector('#cookie-consent-dialogBox .cc-window') ||
                 document.querySelector('.pd-cookie-banner-window.cc-window');
    if (!banner) return;

    var wrapper = banner.closest('#cookie-consent-dialogBox') || banner.closest('.cc-window-wrapper');
    var message = banner.querySelector('.cc-message');
    var compliance = banner.querySelector('.cc-compliance');
    var allow = banner.querySelector('.cc-allow');
    var deny = banner.querySelector('.cc-deny');
    var close = banner.querySelector('.cc-close');
    var buttons = banner.querySelectorAll('.cc-btn');
    var mobile = window.matchMedia('(max-width: 699px)').matches;

    if (wrapper) {
      imp(wrapper, 'background', 'transparent');
      imp(wrapper, 'pointer-events', 'none');
      imp(wrapper, 'padding', '0');
    }

    imp(banner, 'box-sizing', 'border-box');
    imp(banner, 'position', 'fixed');
    imp(banner, 'top', 'auto');
    imp(banner, 'margin', '0');
    imp(banner, 'min-width', '0');
    imp(banner, 'min-height', '0');
    imp(banner, 'background', '#ffffff');
    imp(banner, 'color', '#222222');
    imp(banner, 'border', '1px solid rgba(0,0,0,.10)');
    imp(banner, 'box-shadow', '0 4px 20px rgba(0,0,0,.08)');
    imp(banner, 'pointer-events', 'auto');
    imp(banner, 'overflow', 'visible');
    imp(banner, 'z-index', '2147483000');

    if (mobile) {
      imp(banner, 'left', '8px');
      imp(banner, 'right', '8px');
      imp(banner, 'bottom', '8px');
      imp(banner, 'width', 'auto');
      imp(banner, 'max-width', 'none');
      imp(banner, 'padding', '8px 9px');
      imp(banner, 'display', 'block');
      imp(banner, 'border-radius', '7px');
    } else {
      imp(banner, 'left', '16px');
      imp(banner, 'right', 'auto');
      imp(banner, 'bottom', '16px');
      imp(banner, 'width', '460px');
      imp(banner, 'max-width', 'calc(100vw - 32px)');
      imp(banner, 'padding', '10px 12px');
      imp(banner, 'display', 'flex');
      imp(banner, 'flex-direction', 'row');
      imp(banner, 'align-items', 'center');
      imp(banner, 'gap', '10px');
      imp(banner, 'border-radius', '8px');
    }

    compactEnglishMessage(message);

    if (message) {
      imp(message, 'flex', '1 1 auto');
      imp(message, 'min-width', '0');
      imp(message, 'padding', '0 18px 0 0');
      imp(message, 'font-size', '11px');
      imp(message, 'line-height', mobile ? '1.2' : '1.25');
      imp(message, 'font-weight', '400');
      imp(message, 'text-align', 'left');
      imp(message, 'color', '#555555');
      imp(message, 'margin', mobile ? '0 0 6px 0' : '0');
    }

    if (compliance) {
      imp(compliance, 'margin', '0');
      imp(compliance, 'padding', '0');
      imp(compliance, 'gap', '6px');
      if (mobile) {
        imp(compliance, 'display', 'grid');
        imp(compliance, 'grid-template-columns', 'minmax(0,1fr) minmax(0,1fr)');
        imp(compliance, 'width', '100%');
      } else {
        imp(compliance, 'display', 'flex');
        imp(compliance, 'flex-direction', 'row');
        imp(compliance, 'align-items', 'center');
        imp(compliance, 'width', 'auto');
      }
    }

    buttons.forEach(function (btn) {
      imp(btn, 'box-sizing', 'border-box');
      imp(btn, 'margin', '0');
      imp(btn, 'border-radius', '5px');
      imp(btn, 'font-size', '11px');
      imp(btn, 'font-weight', '500');
      imp(btn, 'text-align', 'center');
      imp(btn, 'box-shadow', 'none');
      if (mobile) {
        imp(btn, 'width', '100%');
        imp(btn, 'min-width', '0');
        imp(btn, 'min-height', '29px');
        imp(btn, 'height', '29px');
        imp(btn, 'padding', '0 8px');
        imp(btn, 'line-height', '27px');
      } else {
        imp(btn, 'width', 'auto');
        imp(btn, 'min-width', '68px');
        imp(btn, 'min-height', '30px');
        imp(btn, 'height', '30px');
        imp(btn, 'padding', '0 10px');
        imp(btn, 'line-height', '28px');
      }
    });

    if (allow) {
      imp(allow, 'background', '#171717');
      imp(allow, 'color', '#ffffff');
      imp(allow, 'border', '1px solid #171717');
    }

    if (deny) {
      imp(deny, 'background', '#ffffff');
      imp(deny, 'color', '#333333');
      imp(deny, 'border', '1px solid #c8c8c8');
    }

    if (close) {
      imp(close, 'position', 'absolute');
      imp(close, 'top', '3px');
      imp(close, 'right', '4px');
      imp(close, 'width', '18px');
      imp(close, 'min-width', '18px');
      imp(close, 'height', '18px');
      imp(close, 'min-height', '18px');
      imp(close, 'padding', '0');
      imp(close, 'margin', '0');
      imp(close, 'background', 'transparent');
      imp(close, 'border', '0');
      imp(close, 'color', '#777777');
      imp(close, 'font-size', '12px');
      imp(close, 'line-height', '18px');
      imp(close, 'opacity', '.55');
      imp(close, 'box-shadow', 'none');
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(applyCompactCookieBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  // Pandectes may inject or replace the banner after theme assets are ready.
  // Because applyCompactCookieBanner is idempotent, observing child additions is safe.
  var observer = new MutationObserver(function (mutations) {
    var relevant = false;

    for (var i = 0; i < mutations.length && !relevant; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;

        if (
          (node.matches && node.matches('#cookie-consent-dialogBox, .pd-cookie-banner-window, .cc-window')) ||
          (node.querySelector && node.querySelector('#cookie-consent-dialogBox, .pd-cookie-banner-window, .cc-window'))
        ) {
          relevant = true;
          break;
        }
      }
    }

    if (relevant) schedule();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  setTimeout(schedule, 250);
  setTimeout(schedule, 1000);
  setTimeout(schedule, 2500);
})();
